import type { ReactNode } from "react";

export const SimulatorPlaygroundBlock = (props: { children: ReactNode }) => {
  return (
    <section className="border-light-1 flex w-full flex-col gap-8 rounded-t-lg border-x border-t p-6 md:w-1/2 md:rounded-l-lg md:rounded-tr-none md:border-y md:border-l md:border-r-0">
      {props.children}
    </section>
  );
};
